import { orderIsFreeDutiesEligible } from "../../utils/orderIsFreeDutiesEligible";
import { RequestDutiesRefundCTA } from "./ctas";
export var RequestDutiesReimbursementIA = function RequestDutiesReimbursementIA(strictLocalize, articles) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize, articles)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize, articles)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2, context.brandOrder);
      }
    }
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return ORDER_NOT_SELECTED(strictLocalize);
  }
  return orderIsFreeDutiesEligible(brandOrder) ? DUTIES_FREE_ORDER(strictLocalize) : NON_DUTIES_FREE_ORDER(strictLocalize);
};
var getPrimaryCTA = function getPrimaryCTA(context, strictLocalize, articles) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return RequestDutiesRefundCTA(strictLocalize, articles);
  }
  if (!orderIsFreeDutiesEligible(brandOrder)) {
    return undefined;
  }
  return RequestDutiesRefundCTA(strictLocalize, articles);
};
var ORDER_NOT_SELECTED = function ORDER_NOT_SELECTED(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return DUTIES_REIMBURSEMENT(strictLocalize);
    },
    getDescription: function getDescription() {
      return [WE_WILL_APPLY_DISCOUNT_IF_DUTIES_ARE_COVERED(strictLocalize), YOU_WILL_PAY_THE_CARRIER_IF_DUTIES_ARE_NOT_COVERED(strictLocalize), EXCLUDE_TAXES_AND_FEES_FROM_REIMBURSEMENT_REQUEST(strictLocalize)];
    }
  };
};
var DUTIES_FREE_ORDER = function DUTIES_FREE_ORDER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return DUTIES_REIMBURSEMENT(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize), EXCLUDE_TAXES_AND_FEES_FROM_REIMBURSEMENT_REQUEST(strictLocalize)];
    }
  };
};
var NON_DUTIES_FREE_ORDER = function NON_DUTIES_FREE_ORDER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return DUTIES_REIMBURSEMENT(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize)];
    }
  };
};
var DUTIES_REIMBURSEMENT = function DUTIES_REIMBURSEMENT(strictLocalize) {
  return strictLocalize({
    id: "YISJZw",
    defaultMessage: [{
      "type": 0,
      "value": "Remboursement des droits de douane"
    }]
  });
};
var WE_WILL_APPLY_DISCOUNT_IF_DUTIES_ARE_COVERED = function WE_WILL_APPLY_DISCOUNT_IF_DUTIES_ARE_COVERED(strictLocalize) {
  return strictLocalize({
    id: "j06O25",
    defaultMessage: [{
      "type": 0,
      "value": "Si les droits de douane sont pris en charge pour votre commande, nous appliquerons lors du passage en caisse une remise correspondant au coût estimé des droits de douane pour votre commande. Le transporteur vous enverra une facture incluant tous les frais (y compris les droits de douane et la TVA), que vous paierez en totalité. Si le coût réel des droits de douane et des frais de débours est supérieur à la remise appliquée, vous pouvez demander le remboursement de la différence en crédit Faire une fois la commande livrée."
    }]
  });
};
var YOU_WILL_PAY_THE_CARRIER_IF_DUTIES_ARE_NOT_COVERED = function YOU_WILL_PAY_THE_CARRIER_IF_DUTIES_ARE_NOT_COVERED(strictLocalize) {
  return strictLocalize({
    id: "8rOH2d",
    defaultMessage: [{
      "type": 0,
      "value": "Si les droits de douane ne sont pas couverts dans votre commande, vous paierez la totalité du montant directement au transporteur et vous ne pourrez pas demander le remboursement des droits de douane."
    }]
  });
};
var EXCLUDE_TAXES_AND_FEES_FROM_REIMBURSEMENT_REQUEST = function EXCLUDE_TAXES_AND_FEES_FROM_REIMBURSEMENT_REQUEST(strictLocalize) {
  return strictLocalize({
    id: "1ckXmV",
    defaultMessage: [{
      "type": 0,
      "value": "Veuillez noter que la TVA, les droits d'accises et les autres frais ne sont pas pris en charge par Faire. Ces coûts ne doivent donc pas être inclus dans votre demande de remboursement."
    }]
  });
};
var ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION = function ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize) {
  return strictLocalize({
    id: "DH6hjb",
    defaultMessage: [{
      "type": 0,
      "value": "Les droits de douane sont pris en charge sur cette commande. Si les droits de douane sont pris en charge pour votre commande, nous appliquerons lors du passage en caisse une remise correspondant au coût estimé des droits de douane pour votre commande. Le transporteur vous enverra une facture incluant tous les frais (y compris les droits de douane et la TVA), que vous paierez en totalité. Si le coût réel des droits de douane et des frais de débours est supérieur à la remise appliquée, vous pouvez demander le remboursement de la différence en crédit Faire une fois la commande livrée."
    }]
  });
};
var ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION = function ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize) {
  return strictLocalize({
    id: "lmtMK2",
    defaultMessage: [{
      "type": 0,
      "value": "Les droits de douane ne sont pas pris en charge sur cette commande. Vous ne pourrez donc pas demander leur remboursement. Le transporteur vous enverra une facture incluant tous les frais (y compris les droits de douane et la TVA), que vous paierez en totalité."
    }]
  });
};